import { Component, OnInit, ElementRef } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-purchase-invoice',
  templateUrl: './purchase-invoice.component.html',
  styleUrls: ['./purchase-invoice.component.css']
})
export class PurchaseInvoiceComponent implements OnInit {

  constructor(public ElementRef:ElementRef,private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
 
  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages  () {
      
      this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage  () {
      this.currentPage = this.currentPage + 1;

  }

  pageSizes  () {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
}
  FilterModel = {
      CurrentIndex: 0,
      InventoryCategoryID: 0,
      PageSize: 20,
      PONumber: '',
      FromDate: '',
      ToDate: '',
      IsActive: true,
      GRNumber: '',
      VendorID: 0,
      POID: 0,
  }
  SearchInvoiceModel = {
      InvoiceNumber: '',
      FromDate: '',
      ToDate: '',
      VendorID: 0,
  }
  ClearSearchInvoice  () {
      this.SearchInvoiceModel.InvoiceNumber = '';
      this.SearchInvoiceModel.FromDate = '';
      this.SearchInvoiceModel.ToDate = '';
      this.SearchInvoiceModel.VendorID = 0;
  }

  POInvoiceModel = {
    AccID:0,
    GRNumber:"",
    ReceivingDate:"",
      POInvoiceID: 0,
      InventoryCategoryID:0,
      InvoiceNumber: '',
      InvoiceDate: '',
      InvoiceAmount: 0,
      VendorID: 0,
      Remarks: '',
      VendorName: '',
      Amount: 0,
      POID: 0,

  }
  ChargeTypeList = [];
  AssetItemList = [];
  GRNItemList = [];
  Selected = false;
  Clear  () {
      this.POInvoiceModel.POInvoiceID = 0;
      this.POInvoiceModel.InvoiceNumber = '';
      this.POInvoiceModel.InvoiceDate = '';
      this.POInvoiceModel.InvoiceAmount = 0;
      this.POInvoiceModel.VendorID = 0;
      this.POInvoiceModel.Remarks = '';
      this.POInvoiceModel.VendorName = '';
      this.POInvoiceModel.Amount = 0;
      this.POInvoiceModel.POID = 0;
      this.ClearSearch();
      this.ChargeTypeList = [];
      this.AssetItemList = [];
      this.GRNItemList = [];
      this.Selected = false;
  }
 
ChargeTypeModel = {
      ChargeTypeID: 0,
      ChargeTypeAmount: 0,
  }
  ClearChargeType  () {
      this.ChargeTypeModel.ChargeTypeID = 0;
      this.ChargeTypeModel.ChargeTypeAmount = 0;
  }
  AddChargeType  () {
      if (this.ChargeTypeValidation() && this.SingleChargeTypeValidation()) {
          var item = {
              ChargeTypeID: this.ChargeTypeModel.ChargeTypeID,
              ChargeType: this.GetChargeType(this.ChargeTypeModel.ChargeTypeID),
              ChargeTypeAmount: 0,
              Remarks: '',

          }
          this.ChargeTypeList.push(item);
          this.ClearChargeType();
      }
  }
  RemoveChargeType  (index) {
      this.ChargeTypeList.splice(index, 1);
      this.CalculateInvoiceAmountManual();
  }
  CalculateInvoiceAmountManual  () {

      this.POInvoiceModel.InvoiceAmount = this.POInvoiceModel.Amount;
      for (var i = 0; i < this.ChargeTypeList.length; i++) {
          this.POInvoiceModel.InvoiceAmount = this.POInvoiceModel.InvoiceAmount + this.ChargeTypeList[i].ChargeTypeAmount == null ? 0 : this.ChargeTypeList[i].ChargeTypeAmount;
      }
  }

  AccountList:any;
  GetAccount  () {
      this.lookupService.GetLookupsList('Acc', '').subscribe( (data)=> {
          this.AccountList = data.LookupItems;
          this.AccountList.splice(0, 1);
        
      });
  };
  POReceivingList:any;
  ItemList:any;
  CheckExits(){
      
      return true
  }
  CalculateInvoiceAmount  (item,index) {
      this.POInvoiceModel.AccID = item.AccID;
      this.POInvoiceModel.ReceivingDate = item.ReceivingDate;
      this.POInvoiceModel.GRNumber = item.GRNumber;
      this.POReceivingList[index].Selected=!item.Selected;
      this.POInvoiceModel.Amount = 0;
      this.POInvoiceModel.InvoiceAmount = 0;
      this.GRNItemList = [];
   
      for (var i = 0; i < this.POReceivingList.length; i++) {
          
           if (this.POReceivingList[i].Selected && this.POReceivingList[i].POInvoiceID==0) {
              this.POInvoiceModel.Amount = (this.POInvoiceModel.Amount) + (this.POReceivingList[i].ReceivingAmount);
          
           for (var j = 0; j < this.POReceivingList[i].ItemList.length; j++) {
             var itemBo={
             AccID:this.POReceivingList[i].ItemList[j].AccID,
             POReceivingItemID:this.POReceivingList[i].ItemList[j].POReceivingItemID,
             ReceivingQty:this.POReceivingList[i].ItemList[j].ReceivingQty,
             UnitPrice:this.POReceivingList[i].ItemList[j].UnitPrice,
             Total :parseFloat(this.POReceivingList[i].ItemList[j].ReceivingQuantity) * parseFloat(this.POReceivingList[i].ItemList[j].UnitPrice)
             }
             var IsExits=false;
             this.POReceivingList[i].ItemList[j].Total = parseFloat(this.POReceivingList[i].ItemList[j].ReceivingQuantity) * parseFloat(this.POReceivingList[i].ItemList[j].UnitPrice)
             this.GRNItemList.push(this.POReceivingList[i].ItemList[j]);
             
            //  if(this.GRNItemList!=null && this.GRNItemList.length>0){
            //     for (var k = 0; k < this.GRNItemList.length; k++) {
            //         if(this.GRNItemList[k].POReceivingItemID==this.POReceivingList[i].ItemList[j].POReceivingItemID){
            //          IsExits=true;
            //          this.GRNItemList[k].ReceivingQty=this.GRNItemList[k].ReceivingQty+this.POReceivingList[i].ItemList[j].ReceivingQty;
            //          this.GRNItemList[k].Total=parseFloat(this.GRNItemList[k].ReceivingQuantity) * parseFloat(this.GRNItemList[k].UnitPrice)
            //         }
                     
            //      }
            //       if(!IsExits){
            //         this.GRNItemList.push(itemBo);
            //       }
            //    }
            // else{
            //     this.GRNItemList.push(itemBo);
            // }
           }
        }
      }
      this.POInvoiceModel.InvoiceAmount = this.POInvoiceModel.Amount;
      
      for (var i = 0; i < this.ChargeTypeList.length; i++) {
          this.POInvoiceModel.InvoiceAmount = (this.POInvoiceModel.InvoiceAmount) + (this.ChargeTypeList[i].ChargeTypeAmount == null ? 0 : this.ChargeTypeList[i].ChargeTypeAmount);
      }
     
    //   this.ItemList = item.ItemList;
     

    //   for (var i = 0; i < this.ItemList.length; i++) {

    //       this.ItemList[i].Total = parseFloat(this.ItemList[i].ReceivingQuantity) * parseFloat(this.ItemList[i].UnitPrice)
    //       this.ItemList[i].ApprovalRemarks = '';

    //       this.GRNItemList.push(this.ItemList[i]);

    //   }
      this.POInvoiceModel.InventoryCategoryID = this.FilterModel.InventoryCategoryID;
      this.IsAssetsGenerate = true;
      if (this.FilterModel.InventoryCategoryID == 3) {
       
          this.GenerateAssets();
          //for (var i = 0; this.ItemList.length; i++) {
          //    this.ItemList[i].Total = 0;
          //    this.ItemList[i].ReceivingQuantity = 0;
          //}
      
      }
  }
  IsAssetsGenerate = false;
  SchoolLocationList:any;
  GetSchoolLocation  () {

      this.spinnerService.show();
      this.lookupService.GetLookupsList('SchoolLocation', '').subscribe( (response)=> {
          this.SchoolLocationList = response.LookupItems;
          this.spinnerService.hide();
      });
  };
  PaymentModeList:any;
  GetPaymentMode  () {
      this.lookupService.GetLookupsList('PaymentMode', '').subscribe( (data)=> {
          this.PaymentModeList = data.LookupItems;
      });
  };

  
  GenerateAssets  () {
     
      this.IsAssetsGenerate = true;
      this.AssetItemList = [];
      for (var i = 0; i < this.ItemList.length; i++) {
                  
          for (var j = 0; j < this.ItemList[i].Quantity; j++) {
              var itemBo = {
                  ItemID: this.ItemList[i].ItemID,
                  ItemName: this.ItemList[i].ItemName,
                  SchoolLocationID: 0,
                  AssetNumber: '',
                  PaymentMode: '',
                  Owner: '',
                  Remarks: '',
                  Rate: '',
                  ItemCategoryID: this.ItemList[i].ItemCategoryID,
                  ReceivingDate: this.ItemList[i].ReceivingDate,
                  Description: this.ItemList[i].Description,
                  InventoryCategoryID: this.ItemList[i].InventoryCategoryID,
                  CategoryName: this.ItemList[i].CategoryName,
                  UOMID: this.ItemList[i].UOMID,
                  UOM: this.ItemList[i].UOM,
                  UnitPrice: this.ItemList[i].UnitPrice,                   
                  EquivalentQty: this.ItemList[i].EquivalentQty
              }

              this.AssetItemList.push(itemBo);
          }

            //  this.AssetItemList.push(this.ItemList[i]);
          
      }
    

  }
  ChargeType:any;
   GetChargeType(ChargeTypeID) {
      for (var i = 0; i < this.ChargeType.length; i++) {
          if (this.ChargeType[i].ItemId == ChargeTypeID)
              return this.ChargeType[i].ItemName;
      }
  };
  VendorList:any;
   GetVendorName(VendorID) {
      for (var i = 0; i < this.VendorList.length; i++) {
          if (this.VendorList[i].ItemId == VendorID)
              return this.VendorList[i].ItemName;
      }
  };
  SingleChargeTypeValidation  () {
      for (var i = 0; i < this.ChargeTypeList.length; i++) {
          if (this.ChargeTypeList[i].ChargeTypeID == this.ChargeTypeModel.ChargeTypeID) {
              alert(' Please Chose a Different ChargeType ');
              return false
          }
      }
      return true;
  }
  ChargeTypeValidation  () {
      if (this.ChargeTypeModel.ChargeTypeID == 0|| this.ChargeTypeModel.ChargeTypeID == 0) {
          alert("Please  Select  ChargeType");
          return false;
      }
      return true;
  }
  Updatecheckbox  () {
      for (var i = 0; i < this.POReceivingList.length; i++) {
          this.POReceivingList[i].Selected = this.Selected;
      }
      // this.CalculateInvoiceAmount();
  }
  ClearSearch  () {
      this.FilterModel.FromDate = '';
      this.FilterModel.ToDate = '';
      this.FilterModel.POID = 0;
      this.FilterModel.VendorID = 0;
  }
  InvoiceViewModel = {
      InvoiceNumber: '',
      VendorName: '',
      InvoiceDate: '',
      InvoiceAmount: 0,
      OtherCharges: 0,
      CancelRemarks: '',
      POInvoiceID: 0,
  }
  ViewInvoiceDetails  (item) {
      this.InvoiceViewModel.POInvoiceID = item.POInvoiceID;
      this.InvoiceViewModel.InvoiceNumber = item.InvoiceNumber;
      this.InvoiceViewModel.VendorName = item.VendorName;
      this.InvoiceViewModel.InvoiceDate = item.InvoiceDate;
      this.InvoiceViewModel.InvoiceAmount = item.InvoiceAmount;
      this.InvoiceViewModel.OtherCharges = item.OtherCharges;
  }
  ClearInvoiceView  () {
      this.InvoiceViewModel.POInvoiceID = 0;
      this.InvoiceViewModel.InvoiceNumber = '';
      this.InvoiceViewModel.VendorName = '';
      this.InvoiceViewModel.InvoiceDate = '';
      this.InvoiceViewModel.InvoiceAmount = 0;
      this.InvoiceViewModel.OtherCharges = 0;
      this.InvoiceViewModel.CancelRemarks = '';
  }
  InventoryCategoryList:any;
  GetInventoryCategory  () {
      this.lookupService.GetLookupsList('StockInventoryCategory', '').subscribe( (data)=> {
          this.InventoryCategoryList = data.LookupItems;
      });
  };
  CancelInvoice  () {
    
       this.spinnerService.show();
       this.stockService.CancelInvoice(JSON.stringify(this.InvoiceViewModel)).subscribe( (data)=> {

         
              this.spinnerService.hide();
           
          this.globalHelper.CheckActionStatus(data);

          this.ClearInvoiceView();
          this.GetAllInvoice();
          // $('#CloseInvoice').click();
      });
  }
   ValidateDropdown() {
      return this.POInvoiceModel.VendorID == 0 || this.POInvoiceModel.POID == 0 || this.POInvoiceModel.POID == 0 || this.POInvoiceModel.InvoiceDate == "";
  };
  Submitted = false;
  POReceivingListValidate = false;
  GRNItemValidation = false;
  AssetItemValidation = false;
  SavePurchaseReceivingInvoice  (valid) {
      this.Submitted = true;
      this.GRNItemValidation = true;
      for (var i = 0; i < this.GRNItemList.length; i++) {
          if (this.GRNItemList[i].AccID==0) {
              this.GRNItemValidation = false;
              break;
          }
      }
      this.AssetItemValidation = true;
      if (this.POInvoiceModel.InventoryCategoryID==3) {
          for (var i = 0; i < this.AssetItemList.length; i++) {
              if (this.AssetItemList[i].SchoolLocationID == 0 || this.AssetItemList[i].PaymentMode == '' || this.AssetItemList[i].Owner == '' || this.AssetItemList[i].Remarks == '' || this.AssetItemList[i].AssetNumber == '' || this.AssetItemList[i].Rate == '') {
                  this.AssetItemValidation = false;
                  break;
              }
          }
      
      }
      for (var i = 0; i < this.GRNItemList.length; i++) {
          if (this.GRNItemList[i].AccID == 0) {
              this.GRNItemValidation = false;
              break;
          }
      }
      for (var i = 0; i < this.POReceivingList.length; i++) {
          if (this.POReceivingList[i].Selected) {
              this.POReceivingListValidate = true;
              break;
          }
      }
      if (valid && !this.ValidateDropdown() && this.GRNItemValidation && this.AssetItemValidation) {
          if (this.POReceivingListValidate) {
              if (this.IsAssetsGenerate) {
            
              this.spinnerService.show();
            
              this.stockService.SavePurchaseReceivingInvoice(JSON.stringify(this.POInvoiceModel), JSON.stringify(this.POReceivingList), JSON.stringify(this.ChargeTypeList), JSON.stringify(this.AssetItemList), JSON.stringify(this.GRNItemList)).subscribe( (data)=> {
                 
                      this.spinnerService.hide();
                      this.Submitted = false;
                      
                      this.POReceivingListValidate = false;
                 
                  this.globalHelper.CheckActionStatus(data);
                  if (data.webResponse.Status) {
                  this.Clear();
                  this.GetAllPOReceivingPayment();
                  this.GetAllInvoice();
                  this.IsAssetsGenerate = false;
              }
              });
                  } else {
                      alert('Please Generate assets first!');
                  }
              }

      }
  }
  IsDisableCheckBox = false;
 
  GetAllPOReceivingPayment  () {
      this.IsDisableCheckBox = false;
      this.Selected = false;
      this.AssetItemList = [];
      this.GRNItemList = [];
      this.POInvoiceModel.VendorID = this.FilterModel.VendorID;
      this.POInvoiceModel.POID = this.FilterModel.POID;
      if(this.FilterModel.VendorID>0){
        this.POInvoiceModel.VendorName =this.GetVendorName(this.FilterModel.VendorID);
      }
     
      
      this.FilterModel.CurrentIndex = this.currentPage;
      this.FilterModel.PageSize = this.pageSize;
      this.spinnerService.show();
      this.stockService.GetAllPOReceivingPayment(JSON.stringify(this.FilterModel)).subscribe( (data)=> {
          this.POReceivingList = data.POReceivingList;
          this.recordCount = 0;
          if (this.POReceivingList != null && this.POReceivingList.length > 0) {
              this.recordCount = this.POReceivingList[0].RecordCount;
          }
          for (var i = 0; i < this.POReceivingList.length; i++) {
              this.POReceivingList[i].Selected = this.Selected;
              if (this.POReceivingList[i].POInvoiceID !=0) {
                  this.IsDisableCheckBox = true;
              }
          }
       
              this.spinnerService.hide();
            
          this.numberOfPages();
      });
  };
  
  GetAllVendor  () {
      this.lookupService.GetLookupsList('Vendor', '').subscribe( (data)=> {
          this.VendorList = data.LookupItems;
      });
  }
 
  GetAllChargeType  () {
      this.lookupService.GetLookupsList('ChargeType', '').subscribe( (data)=> {
          this.ChargeType = data.LookupItems;
      });
  }
  PONumberList:any;
PONumberByVendor  () {
      this.SearchInvoiceModel.VendorID = this.FilterModel.VendorID;
      var item = {
          ItemId: this.FilterModel.VendorID,
      }
      this.lookupService.GetLookupsList('PONumberByVendor', JSON.stringify(item)).subscribe( (data)=> {
          this.PONumberList = data.LookupItems;
      });
      this.GetAllInvoice();
  }
  InvoiceList = [];
  GetAllInvoice  () {
     
      this.spinnerService.show();
      this.stockService.GetAllInvoice(JSON.stringify(this.SearchInvoiceModel)).subscribe( (data)=> {
          this.InvoiceList = data.InvoiceList;
          this.spinnerService.hide();
         
      });
  }
  onSelectName  (item, $item) {
    
      item.AccID = $item.AccID;
      item.AccName = $item.AccName;
    
  }

  ngOnInit() {
       this.GetInventoryCategory();
      this.GetAllChargeType();
      this.GetAllVendor();
      this.GetAllPOReceivingPayment();
      this.GetAllInvoice();
      this.GetAllInvoice();
      this.GetSchoolLocation();
      this.GetPaymentMode();
      this.GetAccount();
  }

}
